import { motion } from "framer-motion";

const CLIENTS = [
  { name: "OSMC", full: "Odisha State Medical Corporation", logo: null },
  { name: "HPCL", full: "Hindustan Petroleum", logo: "/assets/clients/hpcl.png" },
  { name: "IOCL", full: "Indian Oil Corporation", logo: "/assets/clients/iocl.png" },
  { name: "ONGC", full: "Oil & Natural Gas Corporation", logo: "/assets/clients/ongc.png" },
  { name: "Odisha Police", full: "Odisha Police", logo: "/assets/clients/odisha-police.png" },
  { name: "Indian Army", full: "Indian Army", logo: "/assets/clients/army.png" },
  { name: "AAI", full: "Airports Authority of India", logo: "/assets/clients/aai.png" },
  { name: "BARC", full: "Bhabha Atomic Research Centre", logo: "/assets/clients/barc.png" },
  { name: "ESIC", full: "Employees' State Insurance", logo: "/assets/clients/esic.jpg" },
  { name: "NHPC", full: "NHPC Limited", logo: "/assets/clients/nhpc.png" },
  { name: "CTCRI", full: "ICAR-Central Tuber Crops Research Institute", logo: "/assets/clients/ctcri.png" },
  { name: "RMRC", full: "ICMR-Regional Medical Research Centre", logo: "/assets/clients/rmrc.jpg" },
  { name: "AIIMS Bhubaneswar", full: "AIIMS Bhubaneswar", logo: "/assets/clients/aiims-bhubaneswar.png" },
  { name: "NIT Rourkela", full: "National Institute of Technology, Rourkela", logo: "/assets/clients/nit-rourkela.png" },
  { name: "NHM Odisha", full: "National Health Mission, Odisha", logo: "/assets/clients/nhm-odisha.png" },
  { name: "DMCH Keonjhar", full: "Dharanidhar Medical College & Hospital, Keonjhar", logo: "/assets/clients/dmch-keonjhar.png" },
  { name: "MJKMCH Jajpur", full: "Maharaja Jajati Keshari Medical College & Hospital, Jajpur", logo: "/assets/clients/mjkmch-jajpur.png" },
  { name: "Krishna Vikash", full: "Krishna Vikash Multi Speciality Hospital, Bargarh", logo: "/assets/clients/krishna-vikash.png" },
];

export default function TrustedBy() {
  return (
    <section id="trusted-by" className="pb-28 lg:pb-40" data-testid="trusted-by-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-mono-accent text-xs tracking-[0.35em] uppercase text-neon mb-6"
        >
          Trusted By
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight mb-20"
          data-testid="trusted-by-heading"
        >
          Institutions that <span className="text-outline">trust us.</span>
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-5">
          {CLIENTS.map((client, i) => (
            <motion.div
              key={client.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group card-glow border border-white/10 bg-navy-800/40 p-5 flex flex-col items-center justify-center gap-4 min-h-40"
              data-testid={`client-tile-${i}`}
            >
              {client.logo ? (
                <div className="bg-white rounded-sm w-full h-20 flex items-center justify-center p-3">
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="max-h-14 max-w-full object-contain grayscale group-hover:grayscale-0 transition-[filter] duration-500"
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="bg-white rounded-sm w-full h-20 flex items-center justify-center p-3">
                  <span className="font-display text-2xl font-black tracking-tight text-navy">OSMC</span>
                </div>
              )}
              <p className="font-mono-accent text-[10px] tracking-[0.15em] uppercase text-slate-500 group-hover:text-slate-300 text-center transition-colors duration-300">
                {client.full}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
